<alaris-dialog [closeAction]="close.bind(this)"
			   [confirmAction]="confirm.bind(this)"
			   [loading$]="currenciesService.loading$"
			   size="md">
	<h6 slot="header">{{ 'currencies.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3><strong>{{ data.currency.name }}</strong></h3>
	</div>
</alaris-dialog>